<template>
  <div>
    <p>
      実験参加者には、アプリ内アンケートを回答していただいた方に、
      Amazonギフト券Eメールタイプ500円分の薄謝を進呈いたします。
    </p>
  </div>
</template>

<script>
export default {
  name: 'experiment-agree-sentence'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Molecules/ExperimentAgreeSentence.vue